import FormModal from "flarum/common/components/FormModal";
import Button from "flarum/common/components/Button";
import app from "flarum/forum/app";
export default class ResetDiscussionViewsModal extends FormModal {
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Form Form--centered"
    }, m("p", null, app.translator.trans("michaelbelgium-discussion-views.forum.modal_resetviews.label", {
      count: this.attrs.discussion.viewCount()
    })), m("div", {
      className: "Form-group"
    }, Button.component({
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, app.translator.trans("michaelbelgium-discussion-views.forum.modal_resetviews.submit_button")))));
  }
  title() {
    return app.translator.trans("michaelbelgium-discussion-views.forum.modal_resetviews.title");
  }
  className() {
    return "Modal--small";
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    this.attrs.discussion.save({
      resetViews: true
    }).then(() => this.hide()).catch(() => this.loaded());
  }
}
flarum.reg.add('michaelbelgium-discussion-views', 'forum/components/ResetDiscussionViewsModal', ResetDiscussionViewsModal);